import React from "react";
import PropTypes from "prop-types";
import HelperText from "../../../../../../components/atoms/HelperText";
import IndividualPredictionsBarWrapper from "./IndividualPredictionsBarWrapper";

export const IndividualPredictions = ({ insilicoDbs }) => {
  return (
    <div className="tw-flex tw-mx-auto tw-pb-2 tw-mt-6">
      <label className="tw-mt-2 tw-font-bold">Individual Predictions</label>
      <div className="tw-mt-2">
        <HelperText
          title=""
          customText="This is purely a simple representation of the scores to give a quick visual overview, the Germline Variant classifier uses a more sophisticated approach and doesn’t double-count. Note: Engines are assigned a prediction points score based on the strength of the calibrated prediction. Supporting: 1 point. Moderate: 2 points. Strong: 4 points. Very Strong: 8 points"
        />
      </div>
      <div className="tw-scontainer tw-min-w-80 tw-max-w-160 tw-flex-grow tw-text-white tw-ml-4">
        <IndividualPredictionsBarWrapper
          insilicoDbs={insilicoDbs}
          forceDisabledToolTip={false}
          customClass="tw-h-8 tw-text-xs"
        />
      </div>
      <div className="tw-flex-grow" />
    </div>
  );
};

IndividualPredictions.propTypes = {
  insilicoDbs: PropTypes.arrayOf(PropTypes.shape({})),
};

IndividualPredictions.defaultProps = {
  insilicoDbs: null,
};
